var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_error"},[_c('div',[_c('v-icon',{staticClass:"error_icon"},[_vm._v("remove_circle_outline")])],1),_c('div',{staticClass:"error_text"},[_c('h1',[_vm._v("403")]),_c('h3',[_vm._v("Acesso negado")]),_c('p',[_vm._v("O seu acesso a este recurso do SIGED está negado!"),_c('br'),_vm._v(" "+_vm._s(_vm.mensagemErro))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }